import React from 'react'
import './myLayout.css'
import { Layout } from 'react-admin'
import MySidebar from '../MySidebar/MySidebar'
import MyAppBar from '../MyAppBar/MyAppBar'
import { SignalRConnectionProvider } from '../../../../context/useSignalRConnectionContext'
import SetUrlAfterLogin from '../../../../components/SetUrlAfterLogin/SetUrlAfterLogin'
import MobileNotificationModal from '../../../../components/MobileNotificationModal/MobileNotificationModal'
import CloseSidebarWhenSmallScreen from '../../../../components/CloseSidebarWhenSmallScreen/CloseSidebarWhenSmallScreen'
import MyError from '../../MyError/MyError'
import DrawerMenuSmallScreen from '../../../../components/DrawerMenuSmallScreen/DrawerMenuSmallScreen'
import SupportBubble from '../../../../components/SupportBubble/SupportBubble'
import ConsentPopup from '../../../../components/ConsentPopup/ConsentPopup'
import ContractSigningPrompt from '../../../../components/ContractSigningPrompt/ContractSigningPrompt'

const MyLayout = (props) => (
  <SignalRConnectionProvider>
    <Layout {...props} appBar={MyAppBar} sidebar={MySidebar} error={MyError} />
    <SetUrlAfterLogin />
    <CloseSidebarWhenSmallScreen />
    <DrawerMenuSmallScreen />
    <MobileNotificationModal />
    <SupportBubble />
    <ConsentPopup />
    <ContractSigningPrompt />
  </SignalRConnectionProvider>
)

export default MyLayout
